import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom"




import "./Footer.scss"
import { Container, Row, Col } from "react-bootstrap"
import icon1 from "./assets/images/discord-circle.svg"

import icon4 from "./assets/images/twitter-circle.svg"

const Footer = () => {
  let history = useHistory()
  const [hide, setHide] = useState(false)

  useEffect(() => {
    if (history.location.pathname == "/dashboard") {
      setHide(true)
    } else {
      setHide(false)
    }
  }, [history.location.pathname])

  return (
    <>

      <div className='footer_section' style={{ display: hide ? "none" : null }}>



        <div className='footer_div'>
          <Container>

            <Row>
              <Col className='icon_row'>
                <a href='https://discord.com/invite/QTsHxHtj9k' target="_blank"><img className='footer_icon' src={icon1}></img></a>
                <a href='https://twitter.com/angrydwarvesNFT' target="_blank"><img className='footer_icon' src={icon4}></img></a>




              </Col>
            </Row>
            {/* <div className='bottom_line'>SANDAGA LLC</div> */}
          </Container>
        </div>

      </div>

    </>
  )
}

export default Footer
